import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import {IconButton, Icon} from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import AddCircle from '@material-ui/icons/AddCircle';
import {Edit,RemoveCircle} from "@material-ui/icons";
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { LayoutContext } from "App/Layout/store";
import { GetEmpresas } from 'App/Administracion/Actions';
import {AdministracionContext} from "App/Administracion/store";
import {separadorMiles,DigitoVerificador} from 'App/Helpers/Genericos'
import axios from 'axios';
import MUIDataTable from "mui-datatables";
import AgregarEditarEmpresa from "./AgregarEditarEmpresa"

const styles = theme => ({
    root: {
      width: '100%',
      marginTop: theme.spacing.unit * 3,
      overflowX: 'auto',
    },
    table: {
      minWidth: 700,
    },
    textAlignRight: {
        textAlign: "right"
    },
    iconHover: {
        '&:hover': {
            color: "rgb(61,30,144)",
            cursor: "pointer"
        }
    }
});

const convertDataToArray = (data, keys) => data.map(obj => Array.from(keys, k=>obj[k]||null))

function MisClientes(props) {
    const { classes, theme } = props;
    const aministracionContext = useContext(AdministracionContext);
    const layoutContext = useContext(LayoutContext);
    const [empresa,setEmpresa] = useState(null)
    
    useEffect(()=> {
        GetEmpresas(aministracionContext.dispatch)
    }, []);

    function eliminarEmpresa(Rut){
        axios.post("/api/Administracion/Empresas/Eliminar",{Rut}).then(o => {
            alert("Cliente eliminado exitosamente");
            GetEmpresas(aministracionContext.dispatch);
        }).catch(e => /*alert(e.response.data.Mensaje)*/{});
    }


    const columns = [
        { name: "Razón Social", key: "RazonSocial" },
        { name: "Rut", key: "Rut" , options:{customBodyRender:value=>separadorMiles(value)+"-"+DigitoVerificador(value)}},
        { name: "Dirección", key: "Direccion" },
        { name: "Comuna", key: "Comuna" },
        { name: "Correo", key: "Email" },
        { name: "Giro", key: "Giro" },
        { name: "", key: "IdActividadEconomica", options: { display: false } },
        { name: "Documentos Emitidos", key: "Dtes" },
        {
            name: "Acciones", key: "acciones", options: {
                customBodyRender: (value, tableMeta, updateValue) => {
                    var rowData = tableMeta.rowData;
                    return <div style={{width:"6rem"}}>
                        <IconButton onClick={() => setEmpresa({
                            RazonSocial: rowData[0],
                            Rut: rowData[1],
                            Direccion: rowData[2],
                            Comuna: rowData[3],
                            Correo: rowData[4],
                            Giro: rowData[6]
                        })}>
                            <Edit/>
                        </IconButton>
                        {rowData&&!rowData[7]&&<IconButton onClick={(event) => {eliminarEmpresa(rowData[1])}}>
                            <Icon color="error">
                            <RemoveCircle/>
                            </Icon>
                        </IconButton>}
                    </div>
                },
                sort: false
            }
        }
    ]

    return (
        <div>
            <AgregarEditarEmpresa empresa={empresa} cerrar={(cambia)=>{
                setEmpresa(null)
                if(cambia){
                    GetEmpresas(aministracionContext.dispatch);
                }
            }}/>
            <Grid container spacing={24}>
                <Grid item sm={12}>
                    <Typography variant="h5">Mis Clientes</Typography>
                    <Typography variant="subtitle1">Receptores de documentos que no aparecen en el listado de facturadores del SII</Typography>
                    <Typography variant="subtitle2">Sus datos pueden ser modificados</Typography>
                </Grid>
                <Grid item sm={12} className={classes.textAlignRight}>
                    <Tooltip title="Agregar empresa">
                        <Icon color="primary" aria-label="Add" className={classes.iconHover} onClick={(evt) => {
                            evt.preventDefault();
                            setEmpresa({})
                        }}>
                            <AddCircle />
                        </Icon>
                    </Tooltip>
                </Grid>
                <Grid item sm={12}>
                    <Paper className={classes.root}>
                    <MuiThemeProvider theme={()=>createMuiTheme({
                overrides: {
                    MUIDataTable: {
                        responsiveScroll: {
                          maxHeight: 'none',
                        },
                      },
                    MUIDataTableBodyCell: {
                        root: {
                            padding: 4
                        }
                    },
                    MUIDataTableHeadCell:{
                        root:{
                            padding: 4
                        }
                    }
                },
                typography: {
                    useNextVariants: true
                }
            })}>
                    <MUIDataTable
                columns={columns}
                data={convertDataToArray(aministracionContext.state.empresas.listado || [], columns.map(o=>o.key))}
                options={{
                    selection: true,
                    responsive: "scroll",
                    filter:false,
                    print: false,
                    viewColumns:false,
                    sort: true,
                    search: true,
                    download: true,
                }}
            />
            </MuiThemeProvider>
                    </Paper>
                </Grid>
            </Grid>
        </div>
        )
}

MisClientes.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(MisClientes);